import _ from 'lodash';

export const getSelectedStatuses = formValues => {
  const selectedStatuses = _.pickBy(
    formValues,
    (value, key) => _.includes(key, 'Statuses') && value === true
  );

  return Object.keys(selectedStatuses).map(x => {
    return x.match(/\d+/)[0];
  });
};



// WEBPACK FOOTER //
// ./src/pages/rostercurrentbalance/helpers/statusFormatter.js